/**
 * Google Map initialization and voter marker placement.
 */

import { WEST_LAFAYETTE_CENTER, INITIAL_ZOOM } from './config.js';
import {
	theMarkers,
	setMap,
	setMapBounds,
	setMarkerClasses,
} from './state.js';
import { requestUserLocation, handleMapClick } from './geolocation.js';
import { updateMarkerVisibility } from './marker-visibility.js';

/**
 * Initializes the Google Map and adds all markers to the map.
 *
 * @return {Promise<void>}
 */
export async function initMap() {
	const sumyMap = window.sumy_map;
	if ( ! sumyMap ) {
		console.error( 'sumy_map config is missing.' );
		return;
	}

	const mapEl = document.getElementById( 'sumy-neighborhood-map' );
	if ( ! mapEl ) {
		return;
	}

	const { Map } = await google.maps.importLibrary( 'maps' );
	const { AdvancedMarkerElement, PinElement } =
		await google.maps.importLibrary( 'marker' );
	setMarkerClasses( AdvancedMarkerElement, PinElement );

	const mapInstance = new Map( mapEl, {
		zoom: INITIAL_ZOOM,
		zoomControl: true,
		center: WEST_LAFAYETTE_CENTER,
		mapId: 'DEMO_MAP_ID',
	} );
	setMap( mapInstance );

	mapInstance.addListener( 'click', handleMapClick );

	mapInstance.addListener( 'idle', () => {
		const viewBounds = mapInstance.getBounds();
		const ne = viewBounds?.getNorthEast();
		const sw = viewBounds?.getSouthWest();

		console.log( 'Map updated', {
			zoom: mapInstance.getZoom(),
			bounds: viewBounds
				? {
						north: ne.lat(),
						east: ne.lng(),
						south: sw.lat(),
						west: sw.lng(),
				  }
				: null,
		} );

		updateMarkerVisibility();
	} );

	const bounds = new google.maps.LatLngBounds();
	const infoWindow = new google.maps.InfoWindow();
	const markers = Array.isArray( sumyMap.markers ) ? sumyMap.markers : [];

	for ( let i = 0; i < markers.length; i++ ) {
		const markerData = markers[ i ];
		const poiPosition = {
			lat: parseFloat( markerData.position.lat ),
			lng: parseFloat( markerData.position.lng ),
		};

		if ( Number.isNaN( poiPosition.lat ) || Number.isNaN( poiPosition.lng ) ) {
			continue;
		}

		const pin = new PinElement( {
			background: markerData.visited[ 0 ],
			glyphColor: '#ffffff',
			borderColor: '#000',
		} );

		try {
			const poiMarker = new AdvancedMarkerElement( {
				map: null,
				position: poiPosition,
				title: markerData.title,
				content: pin.element,
				gmpClickable: true,
			} );
			poiMarker.url = markerData.url;

			const statusSlug = markerData.visited[ 1 ];
			if ( ! Array.isArray( theMarkers[ statusSlug ] ) ) {
				theMarkers[ statusSlug ] = [];
			}

			poiMarker.addListener( 'click', () => {
				window.location.href = poiMarker.url;
				return;
				const markerContent =
					'<h4><a href="' +
					poiMarker.url +
					'">' +
					poiMarker.title +
					'</a></h4>';
				infoWindow.close();
				infoWindow.setContent( markerContent );
				infoWindow.open( {
					anchor: poiMarker,
					map: mapInstance,
				} );
			} );

			theMarkers[ statusSlug ].push( poiMarker );
			bounds.extend( poiMarker.position );
		} catch ( e ) {
			console.log( e, markerData );
		}
	}

	setMapBounds( bounds );
	mapInstance.setZoom( INITIAL_ZOOM );

	requestUserLocation();
}
